<template id="navbar-routes-wrapper">
  <div class="sm:flex sm:items-center border-t border-grey-lighter md:border-0">
    <div class="px-2 py-5 border-b border-grey-lighter sm:flex sm:border-b-0 sm:py-0 sm:px-0">
      <router-link v-for="(item, index) in allowedItems" :key="item.title" v-bind:to="item.path"
        class="flex items-center justify-between block px-3 py-1 rounded text-grey hover:bg-grey-light sm:mt-0 sm:text-sm sm:px-2 sm:ml-2 xl:hover:bg-grey-lightest xl:px-4 hover:text-green-dark font-semibold"
        :class="{ 'mt-3': index > 0 }">
        <font-awesome-icon :icon="item.icon" class="icon hidden lg:inline-block" size="lg" />
        <span class="ml-0 lg:ml-2">{{ item.title }}</span>
        <font-awesome-icon :icon="['fas', 'angle-right']" class="icon md:hidden" />
      </router-link>
    </div>
    <div class="relative px-5 py-5 sm:py-0 sm:ml-4 sm:px-0 text-grey-darker">
      <div class="flex items-center sm:hidden">
        <font-awesome-icon :icon="['far', 'user-circle']" class="text-2xl" />
        <span class="ml-4 font-semibold sm:hidden">Randy van Santen</span>
      </div>
      <div class="mt-6 sm:hidden">
        <!-- <router-link to="/account" class="block">
          Account
        </router-link> -->
        <a role="button" class="mt-4 block text-red" @click="logout">Uitloggen</a>
      </div>
      <navbar-dropdown class="hidden lg:block"></navbar-dropdown>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import NavbarDropdown from '@/components/header/NavbarDropdown';
import NavigatePerimeter from '@/perimeters/navigate';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  template: '#navbar-routes-wrapper',
  name: 'NavbarRoutes',
  perimeters: [NavigatePerimeter],
  components: {
    FontAwesomeIcon,
    NavbarDropdown
  },
  data() {
    return {
      items: [
        { path: '/', title: 'Objecten', icon: ['fas', 'tasks'], action: 'subject-read' },
        { path: '/complexen', title: 'Complexen', icon: ['fas', 'building'], action: 'subject-read' },
        { path: '/bronnen', title: 'Bronnen', icon: ['fas', 'user-md'], action: 'source-read-all' },
        { path: '/saneerders', title: 'Saneerders', icon: ['fas', 'user-md'], action: 'sanmer-read-all' },
        { path: '/onderzoekers', title: 'Onderzoekers', icon: ['fas', 'user-md'], action: 'investigator-read-all' },
        { path: "/organisaties", title: "Organisaties", icon: ["fas", "building"] },
      ]
    };
  },
  computed: {
    allowedItems() {
      return this.items.filter((item) => {
        return this.$isAllowed('proceed', item.action);
      });
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    }
  }
};
</script>
